import type { ReactNode } from 'react';
import { cn } from '@/shared/lib';

export interface EmptyStateProps {
  title: ReactNode;
  note?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/** Пустое состояние (README §3 «Пусто»): padding 40 24, Display 20 600 ink-700 и пояснение 12 ink-500. */
export function EmptyState({ title, note, action, className }: EmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center gap-6 px-24 py-40 text-center', className)}>
      <span className="font-display text-[20px] leading-[24px] text-ink-700">{title}</span>
      {note ? (
        <span className="max-w-560 text-[12px] leading-[18px] text-ink-500">{note}</span>
      ) : null}
      {action ? <div className="mt-8">{action}</div> : null}
    </div>
  );
}
